import { Dispatch, SetStateAction } from 'react';

export default function OrderController({
  order,
  setOrder,
  disabled,
}: {
  order: string;
  setOrder: Dispatch<SetStateAction<'asc' | 'desc'>>;
  disabled: boolean;
}) {
  function handleOrderChange() {
    if (order == 'asc') {
      setOrder('desc');
    } else {
      setOrder('asc');
    }
  }

  return (
    <img
      src={order == 'asc' ? 'svg/az.svg' : 'svg/za.svg'}
      onClick={handleOrderChange}
      className={`selector-order ${disabled ? 'disabled' : ''}`}
      data-qa-element-id="order_selector"
    />
  );
}
